(function(){
  var preorderMonths = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function formatPreorderDate(value){
    var text = String(value || '').trim();
    var iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
    if(iso) return preorderMonths[Number(iso[2]) - 1] + ' ' + Number(iso[3]) + ', ' + iso[1];
    var written = text.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]+)\s+(\d{4})$/i);
    if(!written) return text;
    var monthIndex = ['january','february','march','april','may','june','july','august','september','october','november','december'].indexOf(written[2].toLowerCase());
    return monthIndex < 0 ? text : preorderMonths[monthIndex] + ' ' + Number(written[1]) + ', ' + written[3];
  }
  function syncButton(button){
    if(!button) return;
    var form = button.closest('form[action*="/cart/add"]');
    if(!form) return;
    var variantId = button.getAttribute('data-fg-preorder-variant-id') || '';
    var arrival = formatPreorderDate(button.getAttribute('data-fg-preorder-arrival'));
    var idInput = form.querySelector('[name="id"]');
    var preorderInput = form.querySelector('[name="properties[_Pre-order]"]');
    var arrivalInput = form.querySelector('[name="properties[Estimated Shipping Date]"]');
    if(idInput && variantId) idInput.value = variantId;
    if(preorderInput) preorderInput.value = 'Yes';
    if(arrivalInput) arrivalInput.value = arrival;
    button.disabled = false;
    button.removeAttribute('disabled');
    button.type = 'submit';
  }

  function syncAll(){
    document.querySelectorAll('[data-fg-bundle-preorder]').forEach(syncButton);
  }

  document.addEventListener('click', function(event){
    var button = event.target.closest('[data-fg-bundle-preorder]');
    if(!button) return;
    syncButton(button);
  }, true);

  document.addEventListener('submit', function(event){
    var button = event.target.querySelector('[data-fg-bundle-preorder]');
    if(button) syncButton(button);
  }, true);

  document.addEventListener('formdata', function(event){
    var button = event.target.querySelector('[data-fg-bundle-preorder]');
    if(!button) return;
    event.formData.set('id', button.getAttribute('data-fg-preorder-variant-id') || '');
    event.formData.set('properties[_Pre-order]', 'Yes');
    event.formData.set('properties[Estimated Shipping Date]', formatPreorderDate(button.getAttribute('data-fg-preorder-arrival')));
  });

  syncAll();
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);
  if(window.MutationObserver){
    new MutationObserver(syncAll).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
  }
})();
